var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.25 7.77779V27.7778C27.25 29.6188 25.7694 31.1111 23.9429 31.1111H4.1001C2.2736 31.1111 0.792969 29.6188 0.792969 27.7778V7.77779C0.792969 5.93682 2.2736 4.44446 4.1001 4.44446H23.9429C25.7687 4.44446 27.25 5.93682 27.25 7.77779ZM40.4786 8.85418V26.6945C40.4786 28.4653 38.4688 29.4993 37.0068 28.4854L29.4548 23.2431V12.3125L37.0061 7.06529C38.4736 6.05071 40.4786 7.09029 40.4786 8.85418Z",
    fill: "#F4730E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.6856,
    height: 35.5556,
    fill: "white",
    transform: "translate(0.792969)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSolid);
export default __webpack_public_path__ + "static/media/video-solid.44a8b48d283805bf4b9fb36f49ff03b8.svg";
export { ForwardRef as ReactComponent };